import React, { createContext, useState, useEffect } from "react";
import { getCurrentUser } from "../Functions/API/services/authService";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  
   
  // Runs when app starts
  useEffect(() => {
    setLoading(true)
    // Validate token & fetch user
    getCurrentUser()
      .then((data) => setUser(data))
      .catch(() => {
        setUser(null);
      })
      .finally(() => {setLoading(false)
      });
  }, []);

  // Login function
  const login = async (token) => { 
    setUser(await getCurrentUser());
  };

  // Logout function
  const logout = () => {
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};